var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatarH(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0014 54.1357C41.9122 54.1357 53.9998 42.0371 53.9998 27.1128C53.9998 12.1884 41.9122 0.0898438 27.0014 0.0898438C12.0905 0.0898438 0.00292969 12.1884 0.00292969 27.1128C0.00292969 42.0371 12.0905 54.1357 27.0014 54.1357Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4929_20324",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9984 54.0459C41.9092 54.0459 53.9968 41.9473 53.9968 27.0229C53.9968 12.0986 41.9092 0 26.9984 0C12.0876 0 0 12.0986 0 27.0229C0 41.9473 12.0876 54.0459 26.9984 54.0459Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4929_20324)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4929_20324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5932 81.4594H38.9961L42.2922 42.3432C42.5881 38.8398 39.8234 35.832 36.3049 35.832H15.2825C11.7659 35.832 9.00123 38.8398 9.29711 42.3432L12.5932 81.4594Z",
    fill: "#0F289D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1265 38.2677H28.2274C29.5013 38.2677 30.5341 37.103 30.5341 35.6689V30.6144C30.5341 29.1784 29.5013 28.0156 28.2274 28.0156H24.1265C22.8526 28.0156 21.8198 29.1803 21.8198 30.6144V35.6689C21.8198 37.1049 22.8526 38.2677 24.1265 38.2677Z",
    fill: "#DB8C96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.0167 28.005C34.3696 33.5796 29.7071 32.7259 24.1326 31.0788C18.558 29.4316 15.375 23.5763 17.0221 18.0017C18.6692 12.4272 24.5246 9.24412 30.0991 10.8912C35.6737 12.5383 37.6638 22.4305 36.0167 28.005Z",
    fill: "#F3B5B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6852 39.418L54.2195 60.9661L44.4706 65.1028L36.71 52.3499L41.6852 39.418Z",
    fill: "#0F289D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41469 36.8321C-2.86895 47.5138 -5.66942 61.6594 -5.66942 61.6594C-6.43267 63.2933 -5.84468 65.9016 -4.13161 66.4651L19.8006 78.4114L23.1325 72.7727L6.37676 60.0142L18.6868 46.7449L18.0479 35.8728C18.0479 35.8728 11.254 35.2321 9.41469 36.8321Z",
    fill: "#0F289D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7263 28.7568C20.3275 29.3071 22.6832 28.5382 21.2453 26.8384C19.487 24.7597 17.887 21.162 20.7666 20.5232C23.6444 19.8843 22.8453 23.3217 24.1231 23.3217C25.4027 23.3217 24.2832 18.7649 24.7619 16.2075C25.2406 13.6501 31.797 13.9686 34.9933 13.4899C38.1914 13.0094 38.5909 6.13635 30.3572 7.09559C24.8109 7.742 20.7647 9.41361 17.2481 14.6904C14.5852 18.68 15.8894 25.2384 19.7263 28.7568Z",
    fill: "#03073C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1616 28.832C30.1616 28.832 30.2012 29.5425 31.918 29.7385C31.918 29.7385 33.3579 29.9024 33.4483 29.1448C33.4464 29.1448 32.1593 28.3665 30.1616 28.832Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4929_20324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.2196,
    height: 74.4575,
    fill: "white",
    transform: "translate(-6 7)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarH);
export default __webpack_public_path__ + "static/media/avatarH.8e2f5045909f66e408f2aee5f92d624e.svg";
export { ForwardRef as ReactComponent };